import type { KPI } from '../../services/api/kpiService';

export const numericKpiValue = (
  kpi: KPI | undefined,
  fallback: number | null = null
): number | null => {
  if (kpi?.value === null || kpi?.value === undefined || kpi.value === '') {
    return fallback;
  }
  const parsed = Number(kpi.value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const percentKpiDisplay = (
  kpi: KPI | undefined,
  suffix: string,
  emptyLabel: string
): string => {
  const value = numericKpiValue(kpi);
  return value === null ? emptyLabel : `${value}% ${suffix}`;
};

export const indexKpiDisplay = (
  kpi: KPI | undefined,
  emptyLabel: string
): string => {
  const value = numericKpiValue(kpi);
  return value === null ? emptyLabel : value.toFixed(2);
};

export const healthStandingFor = (overall: number | null | undefined) => {
  if (overall === null || overall === undefined) return null;
  if (!Number.isFinite(Number(overall))) return null;
  const value = Number(overall);
  if (value >= 80) {
    return { label: 'Good Standing', color: 'success.main' as const };
  }
  if (value >= 60) {
    return { label: 'Needs Attention', color: 'warning.main' as const };
  }
  return { label: 'Critical', color: 'error.main' as const };
};
